"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settingPCCStates_1 = require("./settingPCCStates");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const components_1 = require("@/member/setting/components");
const _1 = require(".");
const PaymentDetailPCCSaveBtn = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@/order/payment_detail/externals/PaymentDetailPCCSaveBtn'))));
function default_1({ deliverySettingData, setDeliverySettingData, isPaymentDetail, }) {
    const { second_customvalue, user_id, default_delivery } = deliverySettingData;
    const hasSavedPCC = Boolean(second_customvalue);
    const settingPCCForm = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        defaultValues: { second_customvalue: second_customvalue || '' },
    });
    (0, react_1.useEffect)(() => {
        settingPCCForm.reset({ second_customvalue: second_customvalue || '' });
    }, [second_customvalue]);
    const [isChangePCC, setIsChangePCC] = (0, recoil_1.useRecoilState)(settingPCCStates_1.isChangePCCState);
    const enableChangePCC = () => setIsChangePCC(true);
    const disableChangePCC = () => setIsChangePCC(false);
    (0, react_1.useEffect)(() => {
        !hasSavedPCC && enableChangePCC();
    }, [hasSavedPCC]);
    const resetIsPCCValid = (0, recoil_1.useResetRecoilState)(settingPCCStates_1.isPCCValidState);
    const cancelPCCSetting = () => {
        settingPCCForm.reset();
        disableChangePCC();
        resetIsPCCValid();
    };
    const isSubmitPCCPending = (0, recoil_1.useRecoilValue)(settingPCCStates_1.isSubmitPCCPendingState);
    const isPCCEditing = isChangePCC && hasSavedPCC;
    const { t } = (0, react_i18next_1.useTranslation)();
    const deliveryName = default_delivery.name;
    const hasDeliveryName = deliveryName !== '구매자 강제 배송완료' && !!deliveryName;
    const subtitleName = hasDeliveryName ? deliveryName : t('받는 사람');
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(components_1.SettingContentsWrapper, Object.assign({ css: { padding: isPaymentDetail && '16px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            columnGap: '12px',
                            marginBottom: '10px',
                        } }, { children: [(0, jsx_runtime_1.jsx)(components_1.SettingSubTitle, Object.assign({ css: { marginBottom: 0 } }, { children: isPaymentDetail ? ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "subtitle3", css: { display: 'flex', alignItems: 'center', columnGap: '6px', flexWrap: 'wrap' } }, { children: [(0, jsx_runtime_1.jsx)("span", { children: subtitleName }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                columnGap: '2px',
                                                flexWrap: 'wrap',
                                            } }, { children: [hasDeliveryName ? ((0, jsx_runtime_1.jsx)("span", { children: t('님의 개인통관고유부호') })) : ((0, jsx_runtime_1.jsx)("span", { children: t('개인통관고유부호') })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "error-main" }, { children: "*" }))] }))] }))) : (t('개인통관고유부호')) })), (0, jsx_runtime_1.jsx)(_1.DeliverySettingPCCCheck, { deliverySettingData: deliverySettingData, settingPCCForm: settingPCCForm })] })), (0, jsx_runtime_1.jsx)(_1.DeliverySettingPCCInput, { deliverySettingData: deliverySettingData, setDeliverySettingData: setDeliverySettingData, settingPCCForm: settingPCCForm, isPaymentDetail: isPaymentDetail })] })), (0, jsx_runtime_1.jsxs)(components_1.SettingSaveCancelWrapper, Object.assign({ css: { display: isPCCEditing ? 'flex' : 'none' } }, { children: [(0, jsx_runtime_1.jsx)(components_1.SettingCancelButton, Object.assign({ onClick: cancelPCCSetting }, { children: t('취소') })), isPaymentDetail ? ((0, jsx_runtime_1.jsx)(PaymentDetailPCCSaveBtn, { setDeliverySettingData: setDeliverySettingData, settingPCCForm: settingPCCForm })) : ((0, jsx_runtime_1.jsx)(components_1.SettingSaveButton, Object.assign({ onClick: (0, _1.savePCCSetting)({
                            user_id,
                            setDeliverySettingData,
                            settingPCCForm,
                        }) }, { children: isSubmitPCCPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 16, color: "info", thickness: 4 })) : ((0, jsx_runtime_1.jsx)("span", { children: t('저장') })) })))] }))] }));
}
exports.default = default_1;
